import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "../useAxiosClient";
import { TRootState } from "../../store";
import { setIsPaymentDetailMove, setIsPaymentHistoryMove, setRefreshMovePmt, setSelectingTradeId } from "../../reducers/trade_details_Slice";
import { TSelectTradeId } from "../../types/trades/trades";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const useMovePayment = () => {
    const { adminId, selectingTradeId, selectedTradeId, selectedDestTraderId, selectedPaymentId, moveSelection, moveComments, openDetailTabs } = useSelector((state: TRootState) => ({
        adminId: state.auth.adminId,
        selectingTradeId: state.tradeDetails.selectingTradeId,
        selectedTradeId: state.tradeDetails.selectedTradeId,
        selectedDestTraderId: state.tradeDetails.selectedDestTraderId,
        selectedPaymentId: state.tradeDetails.selectedPaymentId,
        moveSelection: state.tradeDetails.moveSelection,
        moveComments: state.tradeDetails.moveComments,
        openDetailTabs: state.tradeDetailsById.openDetailTabs,
    }));

    const dispatch = useDispatch();

    const { handleGetCall, handlePutCall } = useAxiosClient();

    useEffect(() => {
        movePaymentTradeIdData();
    }, []);

    const movePaymentTradeIdData = () => {
        handleGetCall<TSelectTradeId[]>(
            `admin/trade-platform/adminId/${adminId}/traderId${selectedDestTraderId}/tradeId/${selectedTradeId}`
        )
            .then(({ data }) => {
                if (data) {
                    dispatch(setSelectingTradeId(data));
                } else {
                    dispatch(setSelectingTradeId([]));
                }
            })
            .catch(() => { });
    };

    const handleSubmitMovePayment = () => {

        if (!moveSelection) {
            toast.error("Please select a Trade");
            return;
        }
        if (!moveComments.trim()) {
            toast.error("Please enter comments");
            return;
        }

        const postBody = {
            addtComments: moveComments,
            adminId: adminId,
            destTradeId: moveSelection,
            pmtId: selectedPaymentId,
            srcTradeId: selectedTradeId
        };

        handlePutCall({
            URL: "admin/trade-platform/trades/update",
            apiParams: postBody,
        })
            .then(({ data, status }) => {
                toast.success(status.message);
                dispatch(setIsPaymentDetailMove(false));
                dispatch(setIsPaymentHistoryMove(false));
                dispatch(setRefreshMovePmt(true));
                window.dispatchEvent(new Event("closePaymentHistory"));
            })
            .catch(() => { });
    };

    return {
        selectingTradeId,
        handleSubmitMovePayment,
        moveSelection,
        moveComments
    }
}
export default useMovePayment; 